module.exports = __webpack_public_path__ + "img/logo.e8726a16.svg";